import { render, staticRenderFns } from "./CoinDetail.vue?vue&type=template&id=7ddf9802&scoped=true&"
import script from "./CoinDetail.vue?vue&type=script&lang=js&"
export * from "./CoinDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoinDetail.vue?vue&type=style&index=0&id=7ddf9802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf9802",
  null
  
)

export default component.exports